import React, { useState } from "react";
import axios from "axios";


const useNoReply = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [noReplyOption, setNoReplyOption] = useState([])
    const mainApi = '/app/no_reply'
    const getNoReplyOption = ({
        user_id,
        is_auto_reply
    }) => {
        axios.get(mainApi, {
            params: {
                user_id,
                is_auto_reply
            }
        })
            .then((response) => {
                let data = response.data?.data || []
                data = data.map((value) => {
                    return {
                        label: value?.content,
                        value: value?.no_reply_id,
                        ...value
                    }
                })
                setNoReplyOption(data)
            });
    }
    const getNoReplyData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                // console.log('靠杯',data)
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postNoReplyData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchNoReplyData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "failure") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteNoReplyData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const getUserNoReply = ({
        no_reply_id,
        customize_title,
        customize_content
    }) => {
        axios
            .get(`/system/user/no_reply`, {
                params: {
                    no_reply_id,
                    customize_title,
                    customize_content
                }
            })
            .then((response) => {

            })
            .catch(() => {

            })
            .finally(() => {
                onFinish({
                    axiosMode: "getUserNoReply",
                    status: 'finish'
                })
            })

    }
    const postUserNoReply = ({
        no_reply_id,
        customize_title,
        customize_content
    }) => {
        axios
            .post(`/system/user/no_reply`, {
                no_reply_id,
                customize_title,
                customize_content
            })
            .then((response) => {

            })
            .catch(() => {

            })
            .finally(() => {
                onFinish({
                    axiosMode: "postUserNoReply",
                    status: 'finish'
                })
            })

    }
    return {
        noReplyOption: noReplyOption,
        noReplyData: data,
        postUserNoReply,
        getUserNoReply,
        getNoReplyData,
        postNoReplyData,
        patchNoReplyData,
        deleteNoReplyData,
        getNoReplyOption
    }
}
export { useNoReply }
